import { render, staticRenderFns } from "./SupplementaryServiceRequest.vue?vue&type=template&id=1d4aa45b"
import script from "./SupplementaryServiceRequest.vue?vue&type=script&lang=js"
export * from "./SupplementaryServiceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports